import http from '@/utils/http';

/**
 * @typedef ProfitAllTime
 *  @property {number} deposit
 *  @property {number} withdrawal
 *  @property {number} total
 */

/**
 * @typedef Profit
 *  @property {number} deposit
 *  @property {number} cashboxProfit
 *  @property {number} masterProfit
 *  @property {number} sumSubagentsProfit
 *  @property {number} withdrawal
 *  @property {number} total
 *  @property {number} depositFee
 *  @property {number} withdrawalFee
 *  @property {number} currentProfit
 *  @property {ProfitAllTime} profitAllTime
 */

/**
 * @param {Date} fromDate
 * @param {Date} toDate
 * @return {Promise<{ data: Profit }>}
 */
export const getProfit = (fromDate, toDate) => http.post('/statistics/profit', {
  fromDate,
  toDate,
});
